import { AutomationsPresentationV1Node } from 'Automations/automationEditor'
import {
  NodeType,
  ResolvedNodeDefinitions
} from 'Automations/nodeDefinitions/types'

// Reads from the resolved registry, not the static `nodeDefinitions`: async
// entries are stored there as functions, so `entry.name` would return the
// function's name (e.g. "startQuoteRequiresApprovalNodeDefinition") rather than
// the definition's display name.
export const getNameForNode = (
  node: AutomationsPresentationV1Node | undefined,
  definitions: ResolvedNodeDefinitions
): string => {
  if (!node || !node.type) return ''

  const customNodeName =
    'name' in node.data && typeof node.data.name === 'string'
      ? node.data.name
      : undefined

  return customNodeName || definitions[node.type as NodeType].name
}
